// @flow

export function isAllTrue (arr: boolean[]): boolean {
	return !arr.find(item => item === false);
}
